import React from 'react';
import { Layout, Breadcrumb, Button } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router';
import { StyledContainer } from './StyledLayout';
import { GET_LIST_POST_REQUEST, UPDATE_FILTER } from '../Post/constant';
import { useDispatch } from 'react-redux';
import Filter from '../Post/Filter';

const { Header, Content } = Layout;

const LayoutComponent = ({ children, title = 'Posts' }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const handleLogout = () => {
    sessionStorage.removeItem('token');
    history.push('/');
  };

  const handleFilter = data => {
    const filter = {
      searchValue: data.searchValue,
      language: data.language === 'all' ? null : data.language,
      author: data.author === -1 ? null : data.author,
      datePublicStart: data.datePublicStart,
      datePublicEnd: data.datePublicEnd,
    };

    dispatch({
      type: UPDATE_FILTER,
      payload: filter,
    });

    dispatch({
      type: GET_LIST_POST_REQUEST,
      payload: {
        skip: 0,
        ...filter,
      },
    });
  };

  return (
    <StyledContainer>
      <Layout style={{ minHeight: '100vh' }}>
        {/* <Sider collapsible collapsed={collapsed} onCollapse={newValue => setCollapsed(newValue)}>
          <div className="logo" />
          <Menu theme="dark" defaultSelectedKeys={['1']} mode="inline">
            <Menu.Item key="1" icon={<PieChartOutlined />}>
              Posts
            </Menu.Item>
            <Menu.Item key="2" icon={<DesktopOutlined />}>
              Option 2
            </Menu.Item>
            <Menu.Item key="9" icon={<FileOutlined />}>
              Files
            </Menu.Item>
          </Menu>
        </Sider> */}
        <Layout className="site-layout">
          <Header className="site-layout-background" style={{ padding: 0 }}>
            <div className="header">
              <Button type="default" onClick={handleLogout}>
                Log out
              </Button>
            </div>
          </Header>
          <Content style={{ margin: '0 16px' }}>
            <Breadcrumb style={{ margin: '16px 0' }}>
              <Breadcrumb.Item>
                <div className="top-box">
                  <div>
                    {title !== 'Posts' && <LeftOutlined onClick={() => history.push('/posts')} />}
                    <h2>{title}</h2>
                  </div>
                  {title === 'Posts' && (
                    <div className="action-box">
                      <Filter onSubmit={handleFilter}>
                        <Button type="primary" onClick={() => history.push('/posts/create')}>
                          Add New
                        </Button>
                      </Filter>

                      {/* <Search placeholder="Search" onSearch={onSearch} style={{ width: 200 }} /> */}
                    </div>
                  )}
                </div>
              </Breadcrumb.Item>
              {/* <Breadcrumb.Item>Bill</Breadcrumb.Item> */}
            </Breadcrumb>
            <div className="site-layout-background">{children}</div>
          </Content>
          {/* <Footer></Footer> */}
        </Layout>
      </Layout>
    </StyledContainer>
  );
};

export default LayoutComponent;
